module.exports = __webpack_public_path__ + "img/bullet-02.bb673aeb.svg";